var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showComponent
    ? _c(
        "div",
        {
          staticClass:
            "bg-white d-flex flex-column justify-content-between position-relative",
          attrs: { flat: "" },
          on: {
            dragover: function ($event) {
              !_vm.usingDeepseek ? _vm.dragover($event) : undefined
            },
            dragleave: function ($event) {
              !_vm.usingDeepseek ? _vm.dragleave() : undefined
            },
            drop: function ($event) {
              !_vm.usingDeepseek ? _vm.drop($event) : undefined
            },
          },
        },
        [
          _c(
            "div",
            {
              ref: "chatContainer",
              staticClass: "chat-container flex-grow-1 d-flex flex-column",
              attrs: { id: "chat-container" },
            },
            [
              _c("audio", {
                ref: "speechMedia",
                staticStyle: { display: "none" },
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.messages.length === 0
                    ? [
                        _c("div", { staticClass: "suggestion-question-list" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center pb-3" },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "100px",
                                  border: "unset",
                                },
                                attrs: { src: _vm.logo, alt: "logo" },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.aiChatQuestions.length > 0
                            ? _c(
                                "div",
                                { staticClass: "d-flex justify-center" },
                                [
                                  _vm.aiChatQuestions[0]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "suggestion-question",
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendSuggestQuestion(
                                                _vm.aiChatQuestions[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-icon",
                                            },
                                            [
                                              _vm.aiChatQuestions[0].icon
                                                ? _c("img", {
                                                    attrs: {
                                                      src: _vm
                                                        .aiChatQuestions[0]
                                                        .icon,
                                                    },
                                                  })
                                                : _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "v-icon material-icons",
                                                    },
                                                    [_vm._v("rate_review")]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.aiChatQuestions[0].title
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.aiChatQuestions[1]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "suggestion-question",
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendSuggestQuestion(
                                                _vm.aiChatQuestions[1]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-icon",
                                            },
                                            [
                                              _vm.aiChatQuestions[1].icon
                                                ? _c("img", {
                                                    attrs: {
                                                      src: _vm
                                                        .aiChatQuestions[1]
                                                        .icon,
                                                    },
                                                  })
                                                : _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "v-icon material-icons",
                                                    },
                                                    [_vm._v("rate_review")]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.aiChatQuestions[1].title
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.aiChatQuestions.length > 2
                            ? _c(
                                "div",
                                { staticClass: "d-flex justify-center" },
                                [
                                  _vm.aiChatQuestions[2]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "suggestion-question",
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendSuggestQuestion(
                                                _vm.aiChatQuestions[2]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-icon",
                                            },
                                            [
                                              _vm.aiChatQuestions[2].icon
                                                ? _c("img", {
                                                    attrs: {
                                                      src: _vm
                                                        .aiChatQuestions[2]
                                                        .icon,
                                                    },
                                                  })
                                                : _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "v-icon material-icons",
                                                    },
                                                    [_vm._v("rate_review")]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.aiChatQuestions[2].title
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.aiChatQuestions[3]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "suggestion-question",
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendSuggestQuestion(
                                                _vm.aiChatQuestions[3]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-icon",
                                            },
                                            [
                                              _vm.aiChatQuestions[3].icon
                                                ? _c("img", {
                                                    attrs: {
                                                      src: _vm
                                                        .aiChatQuestions[3]
                                                        .icon,
                                                    },
                                                  })
                                                : _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "v-icon material-icons",
                                                    },
                                                    [_vm._v("rate_review")]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "suggestion-question-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.aiChatQuestions[3].title
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    : _vm._l(_vm.messages, function (message, messageIndex) {
                        return [
                          message.isBot
                            ? [
                                _c(
                                  "div",
                                  {
                                    key: message.id,
                                    staticClass: "chat incoming",
                                  },
                                  [
                                    _c("div", { staticClass: "chat-content" }, [
                                      _c(
                                        "div",
                                        { staticClass: "chat-details" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: message.userAvatar,
                                              alt: "chatbot-img",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { class: "message-content" },
                                            [
                                              _c(
                                                "v-expansion-panels",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        message.reasoningContent,
                                                      expression:
                                                        "message.reasoningContent",
                                                    },
                                                  ],
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    accordion: "",
                                                    id:
                                                      "message-reasoning-container-" +
                                                      message.id,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-expansion-panel",
                                                    [
                                                      _c(
                                                        "v-expansion-panel-header",
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-end gap-2",
                                                            },
                                                            [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "16px",
                                                                    height:
                                                                      "16px",
                                                                    "padding-right":
                                                                      "4px",
                                                                  },
                                                                  attrs: {
                                                                    xmlns:
                                                                      "http://www.w3.org/2000/svg",
                                                                    viewBox:
                                                                      "0 0 512 512",
                                                                  },
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d: "M184 0c30.9 0 56 25.1 56 56l0 400c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56l0-400c0-30.9 25.1-56 56-56z",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                            思考過程を表示\n                            "
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "streaming-indicator",
                                                                  staticStyle: {
                                                                    display:
                                                                      "none",
                                                                  },
                                                                },
                                                                [_vm._v("●")]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-expansion-panel-content",
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "message-reasoning-content-" +
                                                                  message.id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  message.reasoningContent
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              !message.content
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "typing-animation",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "typing-dot dot1",
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "typing-dot dot2",
                                                      }),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "typing-dot dot3",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                attrs: {
                                                  id:
                                                    "message-content-" +
                                                    message.id,
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    message.content
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              message.attachments.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "chat-input-attachments d-flex flex-column gap-1 mb-2",
                                                    },
                                                    [
                                                      _vm._l(
                                                        message.attachments,
                                                        function (
                                                          attachment,
                                                          index
                                                        ) {
                                                          return [
                                                            [
                                                              "PNG",
                                                              "JPG",
                                                              "JPEG",
                                                            ].includes(
                                                              _vm.getFileExtFromString(
                                                                attachment.filename
                                                              )
                                                            )
                                                              ? _c("img", {
                                                                  key: index,
                                                                  staticClass:
                                                                    "message-attachment-image",
                                                                  attrs: {
                                                                    src: attachment.url,
                                                                    alt: "image",
                                                                  },
                                                                })
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                    staticClass:
                                                                      "chat-input-attachment-container",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "chat-input-attachment d-flex",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.openUrl(
                                                                                attachment.url
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "pr-2",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "FileIcon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    fileName:
                                                                                      attachment.filename,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex flex-column",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "font-weight-bold chat-input-attachment-title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                " +
                                                                                    _vm._s(
                                                                                      _vm.getFileNameFromString(
                                                                                        attachment.filename
                                                                                      )
                                                                                    ) +
                                                                                    "\n                              "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "chat-input-attachment-ext",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getFileExtFromString(
                                                                                      attachment.filename
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: message.contentRaw,
                                                      expression:
                                                        "message.contentRaw",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "message-actions",
                                                  attrs: {
                                                    id:
                                                      "message-" +
                                                      message.id +
                                                      "-actions",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                !message.speechPlaying,
                                                                              expression:
                                                                                "!message.speechPlaying",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          plain:
                                                                            "",
                                                                          icon: true,
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.speech(
                                                                                messageIndex
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "v-icon material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "volume_up"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Read Aloud"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                message.speechPlaying,
                                                                              expression:
                                                                                "message.speechPlaying",
                                                                            },
                                                                          ],
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#343541",
                                                                          },
                                                                        attrs: {
                                                                          plain:
                                                                            "",
                                                                          icon: true,
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            _vm.stopStream,
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "v-icon material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "stop_circle"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Stop"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          plain:
                                                                            "",
                                                                          icon: true,
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.copyMessage(
                                                                                messageIndex
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "v-icon material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "content_copy"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Copy"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                messageIndex +
                                                                                  1 ===
                                                                                _vm
                                                                                  .messages
                                                                                  .length,
                                                                              expression:
                                                                                "messageIndex + 1 === messages.length",
                                                                            },
                                                                          ],
                                                                        attrs: {
                                                                          plain:
                                                                            "",
                                                                          icon: true,
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.regenerate(
                                                                                messageIndex
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "v-icon material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "cached"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("Regenerate"),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    key: message.id,
                                    staticClass: "chat outgoing",
                                  },
                                  [
                                    _c("div", { staticClass: "chat-content" }, [
                                      _c(
                                        "div",
                                        { staticClass: "chat-details" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: message.userAvatar,
                                              alt: "user-img",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              class:
                                                "message-content message-content-" +
                                                message.id,
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(message.content) +
                                                  "\n\n                    "
                                              ),
                                              message.attachments.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "chat-input-attachments d-flex flex-column gap-1 mb-2",
                                                    },
                                                    [
                                                      _vm._l(
                                                        message.attachments,
                                                        function (
                                                          attachment,
                                                          index
                                                        ) {
                                                          return [
                                                            [
                                                              "PNG",
                                                              "JPG",
                                                              "JPEG",
                                                            ].includes(
                                                              _vm.getFileExtFromString(
                                                                attachment.filename
                                                              )
                                                            )
                                                              ? _c("img", {
                                                                  key: index,
                                                                  staticClass:
                                                                    "message-attachment-image",
                                                                  attrs: {
                                                                    src: attachment.url,
                                                                    alt: "image",
                                                                  },
                                                                })
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                    staticClass:
                                                                      "chat-input-attachment-container",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "chat-input-attachment d-flex",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.openUrl(
                                                                                attachment.url
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "pr-2",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "FileIcon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    fileName:
                                                                                      attachment.filename,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex flex-column",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "font-weight-bold chat-input-attachment-title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                " +
                                                                                    _vm._s(
                                                                                      _vm.getFileNameFromString(
                                                                                        attachment.filename
                                                                                      )
                                                                                    ) +
                                                                                    "\n                              "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "chat-input-attachment-ext",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getFileExtFromString(
                                                                                      attachment.filename
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                        ]
                      }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { "margin-top": "10px" },
                attrs: { id: "last-message" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "px-3 pt-3",
              attrs: { id: "message-input-section" },
            },
            [
              _vm.messageCount < _vm.limitMessage
                ? _c("span", { staticClass: "limit-message" }, [
                    _vm._v(
                      "\n        １日に" +
                        _vm._s(_vm.limitMessage) +
                        "回まで" +
                        _vm._s(_vm.messageCount) +
                        "/" +
                        _vm._s(_vm.limitMessage) +
                        "\n      "
                    ),
                  ])
                : _c("span", { staticClass: "limit-message limit-reached" }, [
                    _vm._v(
                      "\n        回数制限に達しました。" +
                        _vm._s(_vm.nextDayFormatted) +
                        " 0:00にリセットされます\n      "
                    ),
                  ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-full p-3" }, [
            _c(
              "div",
              {
                staticClass: "chat-input-container d-flex",
                class: { disabled: _vm.messageCount >= _vm.limitMessage },
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-end" },
                  [
                    !_vm.usingDeepseek
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              plain: "",
                              icon: true,
                              disabled:
                                _vm.inProgress ||
                                _vm.messageCount >= _vm.limitMessage,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addAttachment()
                              },
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass:
                                  "v-icon material-icons theme&#45;&#45;dark",
                              },
                              [_vm._v("attach_file")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class:
                      "d-flex flex-column w-full justify-center " +
                      (_vm.attachments.length ? "gap-1" : ""),
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-input-attachments d-flex flex-column gap-2",
                      },
                      [
                        _vm._l(_vm.attachments, function (attachment, index) {
                          return [
                            _c(
                              "div",
                              {
                                class:
                                  "chat-input-attachment-container " +
                                  (attachment.isDeleted ? "d-none" : ""),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "chat-input-attachment d-flex",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pr-2" },
                                      [
                                        _c("FileIcon", {
                                          attrs: {
                                            fileName: attachment.file.name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-bold chat-input-attachment-title",
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.getFileName(attachment)
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "chat-input-attachment-ext",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.getFileExt(attachment))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "chat-input-progress-bar",
                                  style: {
                                    width: attachment.progressPercentage + "%",
                                    display:
                                      "" +
                                      (attachment.isUploadCompleted
                                        ? "none"
                                        : "block"),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "chat-input-remove-icon" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.inProgress &&
                                              _vm.messageCount <
                                                _vm.limitMessage,
                                            expression:
                                              "!inProgress && messageCount < limitMessage",
                                          },
                                        ],
                                        attrs: { outlined: "", icon: true },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteAttachment(index)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "v-icon material-icons theme&#45;&#45;dark",
                                          },
                                          [_vm._v("close")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column justify-end" },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.chatContent,
                              expression: "chatContent",
                            },
                          ],
                          ref: "chatInput",
                          attrs: {
                            id: "chat-input",
                            placeholder: "内容を入力してください",
                            rows: "1",
                            disabled:
                              _vm.inProgress ||
                              _vm.messageCount >= _vm.limitMessage,
                          },
                          domProps: { value: _vm.chatContent },
                          on: {
                            keydown: _vm.handleEnterChatForm,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.chatContent = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-end" },
                  [
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.inProgress,
                            expression: "inProgress",
                          },
                        ],
                        attrs: { icon: true },
                        on: {
                          click: function ($event) {
                            return _vm.stopGenerate()
                          },
                        },
                      },
                      [
                        _c(
                          "i",
                          { staticClass: "v-icon material-icons theme--dark" },
                          [_vm._v("stop_circle")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.inProgress,
                            expression: "!inProgress",
                          },
                        ],
                        attrs: {
                          plain: "",
                          disabled:
                            !_vm.canSubmit() ||
                            _vm.messageCount >= _vm.limitMessage,
                          icon: true,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.createMessage()
                          },
                        },
                      },
                      [
                        _c(
                          "i",
                          { staticClass: "v-icon material-icons theme--dark" },
                          [_vm._v("send")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              ref: "file",
              staticClass: "hidden",
              attrs: {
                type: "file",
                multiple: "",
                accept: ".jpg, .jpeg, .png",
              },
              on: { change: _vm.handleFileChange },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDragging && !_vm.usingDeepseek,
                  expression: "isDragging && !usingDeepseek",
                },
              ],
              staticClass: "chat-input-backdrop",
            },
            [
              _c("div", { staticClass: "d-flex align-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column justify-center align-center chat-input-drag-message",
                  },
                  [
                    _c("div", { staticClass: "mb-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 132 108",
                            fill: "none",
                            width: "132",
                            height: "108",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: { "clip-path": "url(#clip0_3605_64419)" },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M25.2025 29.3514C10.778 33.2165 8.51524 37.1357 11.8281 49.4995L13.4846 55.6814C16.7975 68.0453 20.7166 70.308 35.1411 66.443L43.3837 64.2344C57.8082 60.3694 60.0709 56.4502 56.758 44.0864L55.1016 37.9044C51.7887 25.5406 47.8695 23.2778 33.445 27.1428L29.3237 28.2471L25.2025 29.3514ZM18.1944 42.7244C18.8572 41.5764 20.325 41.1831 21.4729 41.8459L27.3517 45.24C28.4996 45.9027 28.8929 47.3706 28.2301 48.5185L24.836 54.3972C24.1733 55.5451 22.7054 55.9384 21.5575 55.2757C20.4096 54.613 20.0163 53.1451 20.6791 51.9972L22.8732 48.1969L19.0729 46.0028C17.925 45.3401 17.5317 43.8723 18.1944 42.7244ZM29.4091 56.3843C29.066 55.104 29.8258 53.7879 31.1062 53.4449L40.3791 50.9602C41.6594 50.6172 42.9754 51.377 43.3184 52.6573C43.6615 53.9376 42.9017 55.2536 41.6214 55.5967L32.3485 58.0813C31.0682 58.4244 29.7522 57.6646 29.4091 56.3843Z",
                                  fill: "#AFC1FF",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              attrs: { "clip-path": "url(#clip1_3605_64419)" },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M86.8124 13.4036C81.0973 11.8722 78.5673 13.2649 77.0144 19.0603L68.7322 49.97C67.1793 55.7656 68.5935 58.2151 74.4696 59.7895L97.4908 65.958C103.367 67.5326 105.816 66.1184 107.406 60.1848L115.393 30.379C115.536 29.8456 115.217 29.2959 114.681 29.16C113.478 28.8544 112.435 28.6195 111.542 28.4183C106.243 27.2253 106.22 27.2201 109.449 20.7159C109.73 20.1507 109.426 19.4638 108.816 19.3004L86.8124 13.4036ZM87.2582 28.4311C86.234 28.1567 85.1812 28.7645 84.9067 29.7888C84.6323 30.813 85.2401 31.8658 86.2644 32.1403L101.101 36.1158C102.125 36.3902 103.178 35.7824 103.453 34.7581C103.727 33.7339 103.119 32.681 102.095 32.4066L87.2582 28.4311ZM82.9189 37.2074C83.1934 36.1831 84.2462 35.5753 85.2704 35.8497L100.107 39.8252C101.131 40.0996 101.739 41.1524 101.465 42.1767C101.19 43.201 100.137 43.8088 99.1132 43.5343L84.2766 39.5589C83.2523 39.2844 82.6445 38.2316 82.9189 37.2074ZM83.2826 43.2683C82.2584 42.9939 81.2056 43.6017 80.9311 44.626C80.6567 45.6502 81.2645 46.703 82.2888 46.9775L89.7071 48.9652C90.7313 49.2396 91.7841 48.6318 92.0586 47.6076C92.333 46.5833 91.7252 45.5305 90.7009 45.256L83.2826 43.2683Z",
                                  fill: "#7989FF",
                                },
                              }),
                            ]
                          ),
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M40.4004 71.8426C40.4004 57.2141 44.0575 53.5569 61.1242 53.5569H66.0004H70.8766C87.9432 53.5569 91.6004 57.2141 91.6004 71.8426V79.1569C91.6004 93.7855 87.9432 97.4426 70.8766 97.4426H61.1242C44.0575 97.4426 40.4004 93.7855 40.4004 79.1569V71.8426ZM78.8002 67.4995C78.8002 70.1504 76.6512 72.2995 74.0002 72.2995C71.3492 72.2995 69.2002 70.1504 69.2002 67.4995C69.2002 64.8485 71.3492 62.6995 74.0002 62.6995C76.6512 62.6995 78.8002 64.8485 78.8002 67.4995ZM60.7204 70.8597C60.2672 70.2553 59.5559 69.8997 58.8004 69.8997C58.045 69.8997 57.3337 70.2553 56.8804 70.8597L47.2804 83.6597C46.4851 84.72 46.7 86.2244 47.7604 87.0197C48.8208 87.8149 50.3251 87.6 51.1204 86.5397L58.8004 76.2997L66.4804 86.5397C66.8979 87.0962 67.5363 87.4443 68.2303 87.4936C68.9243 87.5429 69.6055 87.2887 70.0975 86.7967L74.8004 82.0938L79.5034 86.7967C80.4406 87.734 81.9602 87.734 82.8975 86.7967C83.8347 85.8595 83.8347 84.3399 82.8975 83.4026L76.4975 77.0026C75.5602 76.0653 74.0406 76.0653 73.1034 77.0026L68.6601 81.4459L60.7204 70.8597Z",
                              fill: "#3C46FF",
                            },
                          }),
                          _c("defs", [
                            _c(
                              "clipPath",
                              { attrs: { id: "clip0_3605_64419" } },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "56",
                                    height: "56",
                                    fill: "white",
                                    transform:
                                      "translate(0 26.9939) rotate(-15)",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "clipPath",
                              { attrs: { id: "clip1_3605_64419" } },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "64",
                                    height: "64",
                                    fill: "white",
                                    transform:
                                      "translate(69.5645 0.5) rotate(15)",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "800" },
              model: {
                value: _vm.codeDialog,
                callback: function ($$v) {
                  _vm.codeDialog = $$v
                },
                expression: "codeDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", {
                    staticClass: "d-flex pt-6",
                    domProps: { innerHTML: _vm._s(_vm.dialogHTML) },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.codeDialog = false
                            },
                          },
                        },
                        [_vm._v("近い")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", [_vm._v("追加してみましょう")]),
      _vm._v(" "),
      _c("h4", [_vm._v("会話に追加するファイルをここにドロップしてください")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }